<script setup lang="ts">
import { Project } from '@/dashboard/types/project';
import { getProjectCreator } from '@/dashboard/utils/project/getProjectCreator';
import { getProjectCreationDate } from '@/dashboard/utils/project/getProjectCreationDate';

const props = defineProps<{
  project: Project;
}>();

const creator = getProjectCreator(props.project);
const date = getProjectCreationDate(props.project);
</script>

<template>
  <span class="text-caption-s mb-[-7px] mt-s text-left text-gray-500">Created by {{ creator?.name }}: {{ date }}</span>
</template>
